/* eslint-disable react-hooks/exhaustive-deps */
import React, {Fragment, useEffect, useMemo, useState} from 'react';
import {
	DatePicker,
	Divider,
	Drawer,
	Form,
	Input,
	Radio,
	Select,
	Space,
	Button,
	Row,
	Col,
	Typography,
	message,
	InputNumber,
	Spin,
} from 'antd';

import SPUploadPhotos from '../../../base/SPUploadPhotos';
import SPUploadSinglePhoto from '../../../base/SPUploadSinglePhoto';
import SPCompulsoryInsurance from '../SPCompulsoryInsurance';
import SPCommercialInsurance from '../SPCommercialInsurance';
import SPVehicleSelect from '../SPVehicleSelect';
import { encryptTextByAES, decryptTextByAES } from '../../../../utils/encryption';
import emiter, {
  EVENT_VEHICLE_ADD_CAR,
  EVENT_VEHICLE_EDIT_CAR,
  EVENT_VEHICLE_VIEW_CAR,
  EVENT_VEHICLE_RESEARCH,
  EVENT_VEHICLE_TYPE,
  EVENT_VEHICLE_SEARCH_SERIES,
  EVENT_VEHICLE_SEARCH_VEHICLE,
  _EVENTS,
  EVENT_VEHICLE_BATCH_UPLOAD, EVENT_VEHICLE_SEARCH_SERIES_LISTEN, EVENT_VEHICLE_SEARCH_VEHICLE_LISTEN,
} from '../../../../events';
import request from '../../../../request';
import {
  API_VEHICLE_UPLOAD_PHOTO,
  API_VEHICLE_ADD,
  API_VEHICLE_EDIT,
  API_VEHICLE_GET_STORE,
  API_VEHICLE_UPLOAD_PHOTO_BY_TYPE, API_VEHICLE_GET_MODEL_BY_VIN,
} from '../../../../hooks/carRental/_';
import moment from 'moment';
import useModalCloseConfirm from 'hooks/base/modalCloseConfirm';
import _ from 'lodash';
import SPUploadPdfAndImg from '../SPUploadPdfAndImg';

const { Text, Title } = Typography;

interface MyColor {
	name: string;
	color: string;
}

interface PropsType {
	enums?: any;
}

const colorOptions: MyColor[] = [
	{ name: '白色', color: '#FFFFFF' },
	{ name: '黑色', color: '#191919' },
	{ name: '灰色', color: '#DADADA' },
	{ name: '金色', color: '#FFF0E0' },
	{ name: '银色', color: '#F7F7F7' },
	{ name: '红色', color: '#DE4848' },
	{ name: '蓝色', color: '#29ACF4' },
	{ name: '棕色', color: '#976C5D' },
];

const SPVenhicleDrawer: React.FC<PropsType> = props => {
	const { enums } = props;

	const { visible, onOpen, onClose, onOk, onEdited } = useModalCloseConfirm({});

	const [form] = Form.useForm();
	const [inputForm] = Form.useForm();

	const [disable, setDisable] = useState(false);
	const [optionType, setOptionType] = useState('');
	const [vehCode, setVehCode] = useState('');
	const [storeList, setStoreList] = useState([]);

	const [colorList, setColorList] = useState(colorOptions);
	const [isProduct, setIsProduct] = useState(false);
	const [detail, setDetail] = useState<any>(null);
	const [isChange, setIsChange] = useState(false);
	const [isUploading, setIsUploading] = useState(false);

	const mainFormFields = {
		guishumendian: {
			name: 'store_code',
			label: '归属门店',
			required: true,
			message: '请选择归属门店',
			placeholder: '请选择',
		},
		pinpai: {
			name: 'brand_id',
			label: '品牌',
			required: true,
			message: '请选择品牌',
			placeholder: '请选择',
		},
		chexi: {
			name: 'series_id',
			label: '车系',
			required: true,
			message: '请选择车系',
			placeholder: '请选择',
		},
		chexingniankuan: {
			name: 'vehicle_id',
			label: '车型年款',
			required: true,
			message: '请选择车型年款',
			placeholder: '请选择',
		},
		paizhaoleixing: {
			name: 'veh_num_type',
			label: '牌照类型',
			required: true,
			message: '请选择牌照类型',
			placeholder: '请选择',
		},
		// dangqianlicheng: {
		// 	name: 'mileage',
		// 	label: '当前里程',
		// 	required: false,
		// 	message: '请输入当前里程',
		// 	placeholder: '请输入',
		// },
		// ranyoubiaohao: {
		// 	name: 'octane_num',
		// 	label: '燃油标号',
		// 	required: false,
		// 	message: '请选择燃油标号',
		// 	placeholder: '请选择',
		// },
		waiguanyanse: {
			name: 'color',
			label: '外观颜色',
			required: false,
			message: '请选择外观颜色',
			placeholder: '请选择',
		},
		cheliangwaiguantupian: {
			name: 'imgs',
			label: '',
			required: false,
			message: '请上传车辆外观图片',
			placeholder: '请上传',
		},
		xingshizheng: {
			name: 'driving_permit_img',
			label: '',
			required: true,
			message: '请上传行驶证照片',
		},
		chepaihao: {
			name: 'encrypt_veh_plate',
			label: '车牌号',
			required: true,
			message: '请输入正确车牌号',
			placeholder: '请输入',
			pattern: new RegExp(
				'^(京|津|冀|晋|蒙|辽|吉|黑|沪|苏|浙|皖|闽|赣|鲁|豫|鄂|湘|粤|桂|琼|渝|川|贵|云|藏|陕|甘|青|宁|新)[A-Z].{5,6}$'
			),
		},
		// ranyouleixing: {
		// 	name: 'fule_type',
		// 	label: '燃油类型',
		// 	required: false,
		// 	message: '请选择燃油类型',
		// 	placeholder: '请选择',
		// },
		chejiahao: {
			name: 'encrypt_vid',
			label: '车架号',
			required: true,
			message: '请输入正确车架号',
			placeholder: '请输入',
			pattern: new RegExp('^[a-zA-Z0-9]{1,100}$'),
		},
		zhuceriqi: {
			name: 'reg_time',
			label: '注册日期',
			required: true,
			message: '请选择注册日期',
			placeholder: '请选择',
		},
		fadongjihao: {
			name: 'engine_num',
			label: '发动机号',
			required: true,
			message: '请输入正确发动机号',
			placeholder: '请输入',
			pattern: new RegExp('^[a-zA-Z0-9\-]+$'),
		},
		shiyongxingzhi: {
			name: 'srv_type',
			label: '使用性质',
			required: true,
			message: '请选择使用性质',
			placeholder: '请选择',
		},
		hedingzairenshu: {
			name: 'passenger_num',
			label: '核定载人数',
			required: false,
			message: '请输入核定载人数',
			placeholder: '请输入',
		},
		nianjianzheng: {
			name: 'mot_img',
			label: '',
			required: false,
			message: '请上传年检证',
		},
		youxiaoqizhi: {
			name: 'mot_trig_time',
			label: '有效期至',
			required: false,
			message: '请选择有效期至',
			placeholder: '请选择',
		},
		jiaoqiangxiantupian: {
			name: 'traffic_insurance_img',
			label: '',
			required: true,
			message: '请上传交强险图片',
		},
		shangyexiantupian: {
			name: 'commercial_insurance_img',
			label: '',
			required: true,
			message: '请上传商业险图片',
		},
	};

	// 新增状态
	const setType = (type: string) => {
		setOptionType(type);
	};

	// 渲染颜色选择器
	const renderColorOption = (option: MyColor): JSX.Element => {
		return (
			<Space>
				<span>{option.name}</span>
				<span
					style={{
						backgroundColor: option.color,
						width: '50px',
						height: '15px',
						display: 'inline-block',
					}}
				></span>
				<span>{option.color}</span>
			</Space>
		);
	};

	// 打开抽屉
	const opendrawer = (data?: any) => {
		setDetail(null);
		form?.resetFields();
		setIsChange(false);
		if (data && data.veh_brand_id) {
			// 从车型商品定价页面新增车辆
			setIsProduct(true);
			setTimeout(() => {
				emiter.emit(EVENT_VEHICLE_SEARCH_SERIES, data.veh_brand_id);
				if (data.veh_series_id) {
					emiter.emit(EVENT_VEHICLE_SEARCH_VEHICLE, data.veh_series_id);
				}
			}, 100);
			form.setFieldsValue({
				store_code: data.store_code,
				brand_id: data.veh_brand_id,
				series_id: data.veh_series_id,
				vehicle_id: data.veh_model_id || undefined,
				veh_num_type: data.veh_num_type,
			});
		}
		onOpen();
	};

	// 确认关闭
	const confirmClose = () => {
		setDisable(false);
		setColorList([...colorList]);
		inputForm.resetFields();
		setIsProduct(false);
		setDetail(null);
		setIsChange(false);
	};

	// 将获取到的值回显到表单
	const setForm = (formData: any) => {
		setDetail(formData);
		// 加载组件查询列表
		setTimeout(() => {
			if (formData.brand_id) {
				emiter.emit(EVENT_VEHICLE_SEARCH_SERIES, formData.brand_id);
			}
			if (formData.series_id) {
				emiter.emit(EVENT_VEHICLE_SEARCH_VEHICLE, formData.series_id);
			}
		}, 100);
		setVehCode(formData.veh_code);
		const trafficInsurance = formData.traffic_insurance;
		const commercialInsurance = formData.commercial_insurance;
		// 颜色值不是默认就添加一个默认值
		if (formData.color) {
			if (colorList.findIndex((item: any) => item.color === formData.color) === -1) {
				const colorParam = { name: '其他', color: formData.color };
				setColorList([colorParam, ...colorList]);
			}
		}
		form.setFieldsValue({
			...formData,
			encrypt_veh_plate: decryptTextByAES(formData.encrypt_veh_plate),
			encrypt_vid: formData.encrypt_vid ? decryptTextByAES(formData.encrypt_vid) : undefined,
			reg_time: moment(formData.reg_time).isValid() ? moment(formData.reg_time) : undefined,
			mot_trig_time: formData.mot_trig_time ? moment(formData.mot_trig_time) : undefined,
			imgs: formData.imgs ? formData.imgs.split(',') : [],
			// mileage: formData.mileage || undefined,
			fule_type: formData.fule_type || undefined,
			srv_type: formData.srv_type || undefined,
			// octane_num: formData.octane_num || undefined,
			commercial_insurance_img: formData.commercial_insurance_img ? [formData.commercial_insurance_img] : [],
			traffic_insurance_img: formData.traffic_insurance_img ? [formData.traffic_insurance_img] : [],
			traffic_insurance: trafficInsurance
				? {
						...trafficInsurance,
						effect_time: trafficInsurance.effect_time
							? trafficInsurance.effect_time.split(',').map((item: any) => moment(item))
							: undefined,
						attachment: trafficInsurance.attachment ? trafficInsurance.attachment.split(',') : [],
				  }
				: '',
			commercial_insurance: commercialInsurance
				? {
						...commercialInsurance,
						effect_time: commercialInsurance.effect_time
							? commercialInsurance.effect_time.split(',').map((item: any) => moment(item))
							: undefined,
						attachment: commercialInsurance.attachment ? commercialInsurance.attachment.split(',') : [],
						third_insurance_limit: commercialInsurance.third_insurance_limit
							? commercialInsurance.third_insurance_limit / 10000
							: '',
				  }
				: '',
		});
	};

	// 编辑车辆详情
	const editCarInfo = (formValue: any) => {
		onOpen();
		setIsChange(false);
		setForm(formValue);
	};

	// 查看车辆详情
	const viewCarInfo = (formValue: any) => {
		onOpen();
		setDisable(true);
		setIsChange(false);
		setForm(formValue);
	};

	// 拿到最终上传地址
	const getUploadString = (arr: any, type: any) => {
		const finalList: any = [];
		if (arr && arr.length) {
			arr.forEach((item: any) => {
				if (item.file_addr) {
					finalList.push(item.file_addr);
				} else if (optionType === 'edit' && item && typeof item === 'string' && type === 'change') {
					const firstStr = item.split('.com')[1];
					const secondStr = firstStr.split('?')[0];
					finalList.push(secondStr);
				}
			});
		}
		return finalList && finalList.length ? finalList.join(',') : '';
	};

	// 新增、编辑车辆
	const addCarInfo = (callback: any) => {
		if (optionType === 'edit' && !isChange) {
			if (detail?.check_status === 2) {
				message.error('车辆信息无修改，无需审核，执行终止');
				return;
			} else if (detail?.check_status === 3) {
				message.error('车辆信息无修改，请修改驳回项后提交，执行终止');
				return;
			}
		}
		form.validateFields().then((fieldsValue: any) => {
			const outImgs: string[] = [];
			if (optionType === 'new') {
				if (fieldsValue.imgs && fieldsValue.imgs.length) {
					fieldsValue.imgs.forEach((everyImg: any) => {
						if (everyImg.file_addr) {
							outImgs.push(everyImg.file_addr);
						}
					});
				}
			} else if (optionType === 'edit') {
				if (fieldsValue.imgs && fieldsValue.imgs.length) {
					fieldsValue.imgs.forEach((img: any) => {
						if (img && img.file_addr) {
							outImgs.push(img.file_addr);
						} else {
							const firstStr = img.split('.com')[1];
							const secondStr = firstStr.split('?')[0];
							outImgs.push(secondStr);
						}
					});
				}
			}
			// 在审核通过时，车牌号，注册日期，车架号，发动机号，使用性质，核定载人数，不可编辑，不传
			const params = {
				...fieldsValue,
				encrypt_veh_plate:
					(detail && detail?.is_can_change_driving && optionType === 'edit') || optionType === 'new'
						? encryptTextByAES(fieldsValue.encrypt_veh_plate)
						: undefined,
				encrypt_vid:
					(detail && detail?.is_can_change_driving && optionType === 'edit') || optionType === 'new'
						? encryptTextByAES(fieldsValue.encrypt_vid)
						: undefined,
				reg_time:
					(detail && detail?.is_can_change_driving && optionType === 'edit') || optionType === 'new'
						? moment(fieldsValue.reg_time).format('YYYY-MM-DD')
						: undefined,
				engine_num:
					(detail && detail?.is_can_change_driving && optionType === 'edit') || optionType === 'new'
						? fieldsValue.engine_num
						: undefined,
				srv_type:
					(detail && detail?.is_can_change_driving && optionType === 'edit') || optionType === 'new'
						? fieldsValue.srv_type
						: undefined,
				passenger_num:
					(detail && detail?.is_can_change_driving && optionType === 'edit') || optionType === 'new'
						? (fieldsValue.passenger_num || null)
						: undefined,
				veh_code: optionType === 'edit' ? vehCode : undefined,
				imgs: outImgs.length ? outImgs.join(',') : '',
				driving_permit_img:
					(detail && detail?.is_can_change_driving && optionType === 'edit') || optionType === 'new'
						? fieldsValue.driving_permit_img?.file_addr || ''
						: undefined,
				mot_img: fieldsValue.mot_img?.file_addr || '',
				mot_trig_time: fieldsValue.mot_trig_time
					? moment(fieldsValue.mot_trig_time).format('YYYY-MM-DD')
					: undefined,
				traffic_insurance_img: getUploadString(fieldsValue.traffic_insurance_img, 'nochange'),
				commercial_insurance_img: getUploadString(fieldsValue.commercial_insurance_img, 'nochange'),
				traffic_insurance: fieldsValue.traffic_insurance
					? {
							...fieldsValue.traffic_insurance,
							effect_time: fieldsValue.traffic_insurance.effect_time
								? [
										moment(fieldsValue.traffic_insurance.effect_time[0]).format('YYYY-MM-DD'),
										moment(fieldsValue.traffic_insurance.effect_time[1]).format('YYYY-MM-DD'),
								  ].join(',')
								: undefined,
							attachment: getUploadString(fieldsValue?.traffic_insurance?.attachment, 'change'),
					  }
					: undefined,
				commercial_insurance: fieldsValue.commercial_insurance
					? {
							...fieldsValue.commercial_insurance,
							effect_time: fieldsValue.commercial_insurance.effect_time
								? [
										moment(fieldsValue.commercial_insurance.effect_time[0]).format('YYYY-MM-DD'),
										moment(fieldsValue.commercial_insurance.effect_time[1]).format('YYYY-MM-DD'),
								  ].join(',')
								: undefined,
							attachment: getUploadString(fieldsValue?.commercial_insurance?.attachment, 'change'),
							third_insurance_limit: fieldsValue?.commercial_insurance?.third_insurance_limit
								? fieldsValue?.commercial_insurance?.third_insurance_limit * 10000
								: '',
					  }
					: undefined,
			};
			delete params.brand_id;
			delete params.series_id;
			params.passenger_num = params.passenger_num || 0;
			// 提交接口
			request({
				url: optionType === 'new' ? API_VEHICLE_ADD : API_VEHICLE_EDIT,
				method: 'POST',
				data: {
					...params,
				},
			}).then((res: any) => {
				// 关闭抽屉并查询列表
				if (res.errno === 0 && res.data.is_success) {
					message.success(`${optionType === 'new' ? '新增' : '修改'}成功！`);
					if (callback) callback();
					// 关闭弹窗，查询列表
					if (!isProduct) {
						emiter.emit(EVENT_VEHICLE_RESEARCH);
					} else {
						// 查询商品列表
						emiter.emit(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.SEARCH);
					}
				} else {
					message.error(res.errmsg);
				}
			});
		}).catch((error) => {
      if (error?.errorFields?.length) {
        const firstErrorField = document.querySelector(
          `.ant-drawer-content-wrapper #${error.errorFields[0].name.join('-')}`
        );
        firstErrorField?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
	};

	const getStoreList = () => {
		request({
			url: API_VEHICLE_GET_STORE,
			method: 'GET',
		}).then((res: any) => {
			setStoreList(res.data);
		});
	};

	// 添加颜色值
	const addColor = () => {
		inputForm.validateFields().then((values: any) => {
			const param = { name: '其他', color: values.myColor };
			setColorList([param, ...colorList]);
			form.setFieldsValue({ color: values.myColor });
		});
	};

	const handleValuesChange = () => {
		onEdited();
		setIsChange(true);
	};

	const disabledDate = (current: any) => {
		return current && current < moment().startOf('month');
	};

	const validateNum = (_: any, value: any) => {
		if (!value) {
			return Promise.resolve();
		}
		if (value > 9 || value < 1) {
			return Promise.reject(new Error('核定载人数需在1-9人之间'));
		}
		return Promise.resolve();
	};

	const validateTime = (_: any, value: any) => {
		if (value) {
			const lastDay = moment(value).endOf('month');
			const currentDate = moment();
			const differenceInDays = Math.abs(currentDate.diff(lastDay, 'days'));
			if (differenceInDays < 30) {
				return Promise.reject(new Error('年检证有效期需比当前日期大于30天'));
			}
		}
		return Promise.resolve();
	};

	const changeDrive = (data: any) => {
		form.setFieldsValue({
			encrypt_veh_plate: '',
			reg_time: undefined,
			encrypt_vid: '',
			engine_num: '',
			srv_type: undefined,
			passenger_num: null,
		});
    setVehNumType('')
		if (data && !data?.ocr_result && data.file_addr) {
			message.error('OCR识别失败，可重新上传图片');
			return;
		}
		if (data && data?.ocr_result && data?.ocr_result?.file_type === 1) {
			const result = data?.ocr_result?.driving_license || {};
			form.setFieldsValue({
				encrypt_veh_plate: result?.veh_plate || '',
				reg_time: result?.reg_date ? (moment(result?.reg_date).isValid() ? moment(result?.reg_date) : null) : undefined,
				encrypt_vid: result?.vin || '',
				engine_num: result?.engine_no || '',
				srv_type: result?.srv_type || undefined,
				passenger_num: result?.passenger_num || null,
			});
      setCarModelFn(result?.vehicle_model_info || {}, true)
      setVehNumType(result?.veh_plate)
		}
	};

  const setCarModelFn = (vehicle_model_info: any, replaceFlag?: boolean) => {
    const { brand_id, series_id, vehicle_id } = vehicle_model_info || {}
    if (brand_id && series_id && vehicle_id) {
      const obj: any = form.getFieldsValue();
     if (obj.brand_id && obj.series_id && obj.vehicle_id && !replaceFlag) {
       // do-nothing
     } else {
       emiter.emit(EVENT_VEHICLE_SEARCH_SERIES_LISTEN, brand_id);
       emiter.emit(EVENT_VEHICLE_SEARCH_VEHICLE_LISTEN, series_id);
       form.setFieldsValue({
         brand_id: brand_id,
         series_id: series_id,
         vehicle_id: vehicle_id,
       })
     }
    }
  }

  const vehNumTypeObj = useMemo(() => {
    const list = enums.veh_num_type;
    const map: any = {}
    list.forEach((item: any) => {
      if (item.key >= 0) {
        map[item.value?.replace('牌', '')] = item.key
      }
    })
    return map
  }, [enums])

  const setVehNumType = (vehNum: string) => {
    const keys = Object.keys(vehNumTypeObj);
    const findKey = keys?.find((key, index) => {
      return vehNum?.indexOf?.(key) === 0
    })
    if (vehNum && findKey && vehNumTypeObj?.[findKey] !== undefined) {
      form?.setFieldsValue({
        veh_num_type: vehNumTypeObj?.[findKey]
      })
    } else if (!!vehNum) {
      form?.setFieldsValue({
        veh_num_type: 0
      })
    } else {
      form?.setFieldsValue({
        veh_num_type: undefined
      })
    }
  }

  const chepaihaoBlur = (e: any) => {
    setVehNumType(e.target.value)
  }

  const onVinBlur = (e: any) => {
    if (!e.target.value) return
    request({
      url: API_VEHICLE_GET_MODEL_BY_VIN,
      method: 'GET',
      params: {
        vin: e.target.value
      }
    }).then((res) => {
      setCarModelFn(res.data || {}, true)
    })
  }

	const changeTraffic = (data: any) => {
		form.setFieldsValue({
			traffic_insurance: {
				company: '',
				effect_time: [],
				no: '',
				id: '',
			},
		});
		if (data && data.length === 1) {
			const currData = data[0] || {};
			if (currData && !currData?.ocr_result && currData.file_addr) {
				message.error('OCR识别失败，可重新上传图片');
				return;
			}
			if (currData?.ocr_result && currData?.ocr_result?.file_type === 2) {
				const result = currData?.ocr_result?.traffic_insurance || {};
				form.setFieldsValue({
					traffic_insurance: {
						company: result?.company || '',
						effect_time: [
							result?.start_date ? (moment(result?.start_date).isValid() ? moment(result?.start_date) : null) : undefined,
							result?.end_date ? (moment(result?.end_date).isValid() ? moment(result?.end_date) : null) : undefined,
						],
						no: result?.insurance_no || '',
						id: result?.certificate_no || '',
					},
				});
         setCarModelFn(result?.vehicle_model_info || {})
			}
		}
	};

	const changeCommercial = (data: any) => {
		form.setFieldsValue({
			commercial_insurance: {
				company: '',
				effect_time: [],
				no: '',
				id: '',
				third_insurance_limit: '',
			},
		});
		if (data && data.length === 1) {
			const currData = data[0] || {};
			if (currData && !currData?.ocr_result && currData.file_addr) {
				message.error('OCR识别失败，可重新上传图片');
				return;
			}
			if (currData?.ocr_result && currData?.ocr_result?.file_type === 3) {
				const result = currData?.ocr_result?.commercial_insurance || {};
				form.setFieldsValue({
					commercial_insurance: {
						company: result?.company || '',
						effect_time: [
							result?.start_date ? (moment(result?.start_date).isValid() ? moment(result?.start_date) : null) : undefined,
							result?.end_date ? (moment(result?.end_date).isValid() ? moment(result?.end_date) : null) : undefined,
						],
						no: result?.insurance_no || '',
						id: result?.certificate_no || '',
						third_insurance_limit: result?.third_insurance_limit
							? result?.third_insurance_limit / 10000
							: '',
					},
				});
         setCarModelFn(result?.vehicle_model_info || {})
			}
		}
	};

	useEffect(() => {
		emiter.on(EVENT_VEHICLE_ADD_CAR, opendrawer);
		emiter.on(EVENT_VEHICLE_EDIT_CAR, editCarInfo);
		emiter.on(EVENT_VEHICLE_VIEW_CAR, viewCarInfo);
		emiter.on(EVENT_VEHICLE_TYPE, setType);
		getStoreList();
		return () => {
			emiter.removeAllListeners(EVENT_VEHICLE_ADD_CAR);
			emiter.removeAllListeners(EVENT_VEHICLE_EDIT_CAR);
			emiter.removeAllListeners(EVENT_VEHICLE_VIEW_CAR);
			emiter.removeAllListeners(EVENT_VEHICLE_TYPE);
		};
	}, []);

	return (
		<Drawer
			title={
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<span style={{ marginRight: '20px' }}>车辆详情</span>
					{optionType === 'new' ? null : (
						<>
							<Button
								type="primary"
								ghost
								danger={detail?.check_status === 3}
								style={detail?.check_status === 2 ? { color: '#87d068', borderColor: '#87d068' } : {}}
							>
								{_.find(enums?.f_audit_status, ['key', detail?.check_status])?.value}
							</Button>
							{detail?.check_status === 3 ? (
								<div
									style={{
										color: '#808080',
										fontSize: '12px',
										marginLeft: '20px',
										display: 'inline-block',
										width: '82%',
									}}
								>
									驳回原因：{detail?.reject_reason}
								</div>
							) : null}
						</>
					)}
				</div>
			}
			placement="right"
			width="85%"
			onClose={() => onClose({ callback: confirmClose })}
			destroyOnClose
			open={visible}
		>
			<Spin
				spinning={isUploading}
				size="large"
				style={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
				}}
			>
				<Form
					form={form}
					disabled={disable}
					labelCol={{ style: { width: '130px' } }}
					onValuesChange={handleValuesChange}
				>
					<h3>基本信息</h3>
					<Row gutter={24}>
						<Col span={24}>
							<Space align="baseline">
								<Form.Item
									name={mainFormFields.guishumendian.name}
									label={mainFormFields.guishumendian.label}
									rules={[
										{
											required: mainFormFields.guishumendian.required,
											message: mainFormFields.guishumendian.message,
										},
									]}
									wrapperCol={{ style: { width: 450 } }}
								>
									<Select
										showSearch
										optionFilterProp="children"
										disabled={optionType === 'edit' || optionType === 'view' || isProduct}
										placeholder={mainFormFields.guishumendian.placeholder}
										allowClear
										getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
									>
										{storeList &&
											storeList.map((item: any) => (
												<Select.Option value={item.store_code} key={item.store_code}>
													{item.store_name}
												</Select.Option>
											))}
									</Select>
								</Form.Item>
							</Space>
						</Col>
					</Row>
					<SPVehicleSelect
						mainFormFields={mainFormFields}
						form={form}
						optionType={optionType}
						isProduct={isProduct}
						detail={detail}
						enums={enums}
					/>
					<Form.Item
						name={mainFormFields.paizhaoleixing.name}
						label={mainFormFields.paizhaoleixing.label}
						rules={[
							{
								required: mainFormFields.paizhaoleixing.required,
								message: mainFormFields.paizhaoleixing.message,
							},
						]}
					>
						<Radio.Group disabled={optionType === 'view' || isProduct}>
							<Space>
								{enums &&
									enums.veh_num_type &&
									enums.veh_num_type
										.filter((item: any) => item.key !== -1)
										.map((vehNum: any) => (
											<Radio key={vehNum.key} value={vehNum.key}>
												{vehNum.value}
											</Radio>
										))}
							</Space>
						</Radio.Group>
					</Form.Item>
					<Row gutter={24}>
						<Col span={16}>
							<Form.Item
								name={mainFormFields.waiguanyanse.name}
								label={mainFormFields.waiguanyanse.label}
								rules={[
									{
										required: mainFormFields.waiguanyanse.required,
										message: mainFormFields.waiguanyanse.message,
									},
								]}
							>
								<Select
									placeholder={mainFormFields.waiguanyanse.placeholder}
									allowClear
									getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
									dropdownRender={menu => (
										<>
											{menu}
											<Divider style={{ margin: '8px 0' }} />
											<Space style={{ padding: '0 8px 4px' }} align="baseline">
												<Form form={inputForm}>
													<Form.Item
														name="myColor"
														rules={[
															{
																required: true,
																message: '请输入正确的颜色值',
																pattern: new RegExp(
																	'^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
																),
															},
														]}
													>
														<Input placeholder="请输入正确的颜色值" />
													</Form.Item>
												</Form>
												<Button type="link" onClick={addColor}>
													添加颜色值
												</Button>
											</Space>
										</>
									)}
								>
									{colorList &&
										colorList.map(option => (
											<Select.Option key={option.color} value={option.color}>
												{renderColorOption(option)}
											</Select.Option>
										))}
								</Select>
							</Form.Item>
						</Col>
					</Row>
					<Text>车辆外观图片 最多上传6张，≤10M/张，图片格式仅限.jpg、.png、.jpeg</Text>
					<Form.Item
						name={mainFormFields.cheliangwaiguantupian.name}
						label={mainFormFields.cheliangwaiguantupian.label}
						rules={[
							{
								required: mainFormFields.cheliangwaiguantupian.required,
								message: mainFormFields.cheliangwaiguantupian.message,
							},
						]}
					>
						<SPUploadPhotos
							action={API_VEHICLE_UPLOAD_PHOTO}
							name={mainFormFields.cheliangwaiguantupian.name}
							maxNum={6}
							fileSize={10}
							hideTitle
						/>
					</Form.Item>
					<Divider dashed style={{ borderColor: '#000' }} />
					<Space align="baseline">
						<Text type="danger">*</Text>
						<Title level={5}>行驶证</Title>
						<Text type="secondary">
							请上传行驶证照片，请保证图片内容清晰，无反光，无折痕，背景无杂物，图片格式仅限.jpg、.png、.jpeg
						</Text>
					</Space>
					<Row gutter={24}>
						<Col span={6}>
							<Form.Item
								name={mainFormFields.xingshizheng.name}
								label={mainFormFields.xingshizheng.label}
								rules={[
									{
										required: mainFormFields.xingshizheng.required,
										message: mainFormFields.xingshizheng.message,
									},
								]}
							>
								<SPUploadSinglePhoto
									onChange={changeDrive}
									action={`${API_VEHICLE_UPLOAD_PHOTO_BY_TYPE}1`}
									name={mainFormFields.xingshizheng.name}
									fileSize={10}
									hideTitle
									isDisabled={(detail && !detail?.is_can_change_driving) || optionType === 'view'}
									setIsUploading={setIsUploading}
								/>
							</Form.Item>
						</Col>
						<Col span={18}>
							<Row gutter={24}>
								<Col span={12}>
									<Form.Item
										name={mainFormFields.chepaihao.name}
										label={mainFormFields.chepaihao.label}
										rules={[
											{
												required: mainFormFields.chepaihao.required,
												message: mainFormFields.chepaihao.message,
												pattern: mainFormFields.chepaihao.pattern,
											},
										]}
									>
										<Input
                      onBlur={chepaihaoBlur}
											disabled={
												(detail && !detail?.is_can_change_driving) || optionType === 'view'
											}
											placeholder="请输入"
										/>
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item
										name={mainFormFields.zhuceriqi.name}
										label={mainFormFields.zhuceriqi.label}
										rules={[
											{
												required: mainFormFields.zhuceriqi.required,
												message: mainFormFields.zhuceriqi.message,
											},
										]}
									>
										<DatePicker
											disabled={
												(detail && !detail?.is_can_change_driving) || optionType === 'view'
											}
											getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
											placeholder={mainFormFields.zhuceriqi.placeholder}
										/>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col span={12}>
									<Form.Item
										name={mainFormFields.chejiahao.name}
										label={mainFormFields.chejiahao.label}
										rules={[
											{
												required: mainFormFields.chejiahao.required,
												message: mainFormFields.chejiahao.message,
												pattern: mainFormFields.chejiahao.pattern,
											},
										]}
									>
										<Input
											maxLength={100}
											showCount
											placeholder={mainFormFields.chejiahao.placeholder}
											allowClear
                      onBlur={onVinBlur}
											disabled={
												(detail && !detail?.is_can_change_driving) || optionType === 'view'
											}
										/>
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item
										name={mainFormFields.fadongjihao.name}
										label={mainFormFields.fadongjihao.label}
										rules={[
											{
												required: mainFormFields.fadongjihao.required,
												message: mainFormFields.fadongjihao.message,
												pattern: mainFormFields.fadongjihao.pattern,
											},
										]}
									>
										<Input
											maxLength={100}
											showCount
											placeholder={mainFormFields.fadongjihao.placeholder}
											allowClear
											disabled={
												(detail && !detail?.is_can_change_driving) || optionType === 'view'
											}
										/>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col span={12}>
									<Form.Item
										name={mainFormFields.shiyongxingzhi.name}
										label={mainFormFields.shiyongxingzhi.label}
										rules={[
											{
												required: mainFormFields.shiyongxingzhi.required,
												message: mainFormFields.shiyongxingzhi.message,
											},
										]}
									>
										<Select
											placeholder={mainFormFields.shiyongxingzhi.placeholder}
											options={(enums as any)?.srv_use_type}
											fieldNames={{ label: 'value', value: 'key' }}
											allowClear
											getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
											disabled={
												(detail && !detail?.is_can_change_driving) || optionType === 'view'
											}
										/>
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item
										name={mainFormFields.hedingzairenshu.name}
										label={mainFormFields.hedingzairenshu.label}
										rules={[
											{
												validator: validateNum,
											},
										]}
									>
										<InputNumber
											controls={false}
											precision={0}
											disabled={
												(detail && !detail?.is_can_change_driving) || optionType === 'view'
											}
										/>
									</Form.Item>
								</Col>
							</Row>
						</Col>
					</Row>
					<Space align="baseline">
						<Title level={5}>年检证</Title>
						<Text type="secondary">正确维护年检证有效期，系统将根据有效期提示年检，降低运营风险，图片格式仅限.jpg、.png、.jpeg</Text>
					</Space>
					<Row gutter={24}>
						<Col span={6}>
							<Form.Item
								name={mainFormFields.nianjianzheng.name}
								label={mainFormFields.nianjianzheng.label}
								rules={[
									{
										required: mainFormFields.nianjianzheng.required,
										message: mainFormFields.nianjianzheng.message,
									},
								]}
							>
								<SPUploadSinglePhoto
									action={API_VEHICLE_UPLOAD_PHOTO}
									name={mainFormFields.nianjianzheng.name}
									fileSize={10}
									hideTitle
								/>
							</Form.Item>
						</Col>
						<Col span={18}>
							<Form.Item
								name={mainFormFields.youxiaoqizhi.name}
								label={mainFormFields.youxiaoqizhi.label}
								rules={[
									{
										validator: validateTime,
									},
								]}
							>
								<DatePicker
									placeholder={mainFormFields.youxiaoqizhi.placeholder}
									format="YYYY-MM"
									picker="month"
									disabledDate={disabledDate}
									getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Space align="baseline">
						<Text type="danger">*</Text>
						<Title level={5}>交强险保单</Title>
						<Text type="secondary">保单请确保未退保、未过期，格式仅限.jpg、.png、.jpeg、.pdf</Text>
					</Space>
					<Row gutter={24}>
						<Col span={6}>
							<Form.Item
								name={mainFormFields.jiaoqiangxiantupian.name}
								label={mainFormFields.jiaoqiangxiantupian.label}
								rules={[
									{
										required: mainFormFields.jiaoqiangxiantupian.required,
										message: mainFormFields.jiaoqiangxiantupian.message,
									},
								]}
							>
								<SPUploadPdfAndImg
									onChange={changeTraffic}
									action={`${API_VEHICLE_UPLOAD_PHOTO_BY_TYPE}2`}
									fileSize={10}
									fileNum={1}
									setIsUploading={setIsUploading}
									disabled={disable}
								/>
							</Form.Item>
						</Col>
						<Col span={18}>
							<Form.Item name="traffic_insurance">
								<SPCompulsoryInsurance disabled={disable} />
							</Form.Item>
						</Col>
					</Row>
					<Space align="baseline">
						<Text type="danger">*</Text>
						<Title level={5}>商业险保单</Title>
						<Text type="secondary">保单请确保未退保、未过期，格式仅限.jpg、.png、.jpeg、.pdf</Text>
					</Space>
					<Row gutter={24}>
						<Col span={6}>
							<Form.Item
								name={mainFormFields.shangyexiantupian.name}
								label={mainFormFields.shangyexiantupian.label}
								rules={[
									{
										required: mainFormFields.shangyexiantupian.required,
										message: mainFormFields.shangyexiantupian.message,
									},
								]}
							>
								<SPUploadPdfAndImg
									onChange={changeCommercial}
									action={`${API_VEHICLE_UPLOAD_PHOTO_BY_TYPE}3`}
									fileSize={10}
									fileNum={1}
									setIsUploading={setIsUploading}
									disabled={disable}
								/>
							</Form.Item>
						</Col>
						<Col span={18}>
							<Form.Item name="commercial_insurance">
								<SPCommercialInsurance disabled={disable} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<Space>
						<Button onClick={() => onClose({ callback: confirmClose })}>
							{optionType === '查看' ? '关闭' : '取消'}
						</Button>
						{optionType === 'view' ? null : (
							<Button type="primary" onClick={() => onOk({ callback: addCarInfo })}>
								提交审核
							</Button>
						)}
					</Space>
				</div>
			</Spin>
		</Drawer>
	);
};

export default SPVenhicleDrawer;
